import { render, staticRenderFns } from "./ButtonWithIcon.vue?vue&type=template&id=0c65c922&"
import script from "./ButtonWithIcon.vue?vue&type=script&lang=js&"
export * from "./ButtonWithIcon.vue?vue&type=script&lang=js&"
import style0 from "./ButtonWithIcon.vue?vue&type=style&index=0&id=0c65c922&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports